import React from "react";
import { Card, CardBody, CardHeader } from "../../partials/controls";

const Unauthorized: React.FC = () => {
  return (
    <div className="d-flex flex-column flex-root">
      <div className="d-flex flex-row-fluid flex-center justify-content-center">
        <div className="d-flex flex-column justify-content-center text-center">
          <h1 className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15">
            403
          </h1>
          <p className="font-size-h3 font-weight-light">
            Access Denied
          </p>

          <Card className="mt-10">
            <CardHeader title="You don't have permission to access this page" />
            <CardBody>
              <p className="text-muted">
                If you believe this is an error, please contact your administrator
                or check your permissions settings.
              </p>
              <div className="mt-5">
                <a href="/welcome" className="btn btn-primary font-weight-bold">
                  Go to Welcome Page
                </a>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
